import React, { useState, useEffect, createContext } from "react";
import { LightThemeProvider } from "@monorepo/theme-provider";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/router";
import { Global } from "@emotion/react";
import { globalStyles } from "./globalStyles";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useTranslation } from "@monorepo/localization";
import { loadOneTrustSnippet } from "./util/onetrust";
import { loadAdobeDTM } from "./util/adobe";
import { getPageLocale } from "@monorepo/utils/locales";
import "./tailwind.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});

export const EmailTokenFlowContext = createContext(null);

const App = () => {
    const { t } = useTranslation("privacy-portal");
    const [isEmailTokenFlow, setIsEmailTokenFlow] = useState(false);
    useEffect(() => {
        document.title = t("NVIDIA Privacy");
        document.documentElement.setAttribute("lang", getPageLocale());
        loadOneTrustSnippet();
        loadAdobeDTM();
    }, []);
    return (
        <LightThemeProvider>
            <EmailTokenFlowContext.Provider value={{ isEmailTokenFlow, setIsEmailTokenFlow }}>
                <QueryClientProvider client={queryClient}>
                    <Global styles={globalStyles} />
                    <RouterProvider router={router} />
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </EmailTokenFlowContext.Provider>
        </LightThemeProvider>
    );
};

export default App;
